export const rangeFromLimitValidator = (props: {
  rangeFrom: number | string | null | undefined;
  limitTo: number | string | null | undefined;
  isRequired?: boolean;
}) => {
  const { rangeFrom, limitTo, isRequired } = props;
  const isRangeFromEmpty = rangeFrom === "" || rangeFrom === null || rangeFrom === undefined;
  const isLimitToEmpty = limitTo === "" || limitTo === null || limitTo === undefined;
  if (isRequired && isRangeFromEmpty) return false;
  if (isRangeFromEmpty || isLimitToEmpty) return true;
  if (Number(rangeFrom) > Number(limitTo)) return false;
  return true;
};
